import api from "@/axios/chat/index.js";
import useTourists from "@/hooks/tourists/index.js";
import useCs from "@/hooks/cs/index.js";


// 传话任务
export default function useTaskMsg() {
    const {getCompanyId, getTouristsId} = useTourists()
    const {getCsId} = useCs()

    // 呼唤问题
    const emitQuestion = async () => {
        const kefu_sfid = await getCsId()
        const send_sfid = await getTouristsId()
        return api.emitTurms({
            scene: "question_list", send_sfid, kefu_sfid
        }).then(res => {
            return res
        }).catch(err => {
            console.log("呼唤问题-err", err)
        })
    }

    // 呼唤答案
    const emitAnswer = async (questionId) => {
        const kefu_sfid = await getCsId()
        const send_sfid = await getTouristsId()

        return api.emitTurms({
            scene: "question_answers",
            send_sfid,
            company_sfid: getCompanyId(),
            question_id: questionId,
            kefu_sfid
        })
    }

    // 留言
    const emitLeaveMessage = async () => {
        const kefu_sfid = await getCsId()
        const send_sfid = await getTouristsId()

        return api.emitTurms({
            scene: "kefu_leaving",
            send_sfid,
            company_sfid: getCompanyId(),
            kefu_sfid
        })
    }
    return {
        emitAnswer,
        emitQuestion,
        emitLeaveMessage
    }
}
